export default __webpack_public_path__ + "static/media/scande-hero.98d8d095.mp4";